import {
    CaretRightOutlined,
    RightOutlined,
    MinusCircleOutlined,
    PlusOutlined,
    EditOutlined,
    CloseOutlined,
    DeleteOutlined,
    SendOutlined
 
} from "@ant-design/icons";
import { Row, Col, Form, Input, Divider, Select, Button, Space, DatePicker, Table, Tag } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import accountService from "../../../api/account.service";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";





const { Option } = Select;

const AccountDrCrDetailsGeneralSingleRow = (props) => {
    const [accountList, setAccountList] = useState([]);
    const [paymentModeList, setPaymentModeList] = useState([]);
    const [extraaPaidAmountInfo, setExtraaPaidAmountInfo] = useState("");
    
   
    const [isPaymentModereadOnlyDisable, setIsPaymentModereadOnlyDisable] = useState(false);




    const columns = [
        {
          title: 'Tag',
          dataIndex: 'ac_tag',
          key: 'ac_tag',
          
          
        },
        {
            title: 'Account',
            dataIndex: 'account_id',
            key: 'A/C',
            render: (text, record, index) =>  (
                <div>
                    {
                       <span>{record.account_title}</span>
                    }
                </div>
            )
            
        },
        {
          title: 'Amount',
          dataIndex: 'amount',
          key: 'amount',
        },
       
        {
            title: 'Action',
            key: 'action',
            render: (text, record, index) =>  (
                    <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=>props.removeVocherDetail(index)} > Remove <DeleteOutlined /> </Button>
                )
          },
        
    
        
      ];



    const onAccountChange = (value, object) => {
        props.form.setFieldsValue({
            account_title : object.children
        })
    }


   

    /*
    const onPaymentDateSelect = (date, dateString) => {
        console.log(date, dateString);
        props.enrollmentForm.setFieldsValue({
          payment_date: dateString,
        });
      };
    */

    useEffect(() => {
        accountService.accountListForJournal().then((res) => {
            setAccountList(res.data.response_data);
        });
    }, []);

    /*
    useEffect(() => {
        accountService.paymentModeList().then((res) => {
            setPaymentModeList(res.data.response_data);
        });
    }, [])


    useEffect(()=>{
        props.enrollmentForm.setFieldsValue({
            paid_amount:props.remainingAmount.toFixed(2),
            short_excess_amount:props.remainingAmount.toFixed(2)
        })

        onPaymentAmountChange(null)
    },[props.remainingAmount]);

    useEffect(()=>{
        setExtraaPaidAmountInfo("");
        props.enrollmentForm.setFieldsValue({
            payment_data:props.paymentPaidList
        });
       
    },[props.paymentPaidList])
    */

    useEffect(()=> {
        props.form.setFieldsValue({
            voucher_details:props.voucherDetailsList
        });
       
    },[props.voucherDetailsList])
    


    return (
        <>
            
            <Row gutter={20}>
                <Col xs={24} xl={24}>
                    <h4 style={{
                        borderBottom:'1px dashed #aaa',
                        paddingBottom:'0.5rem',
                        marginBottom:'14px'
                    }}><SendOutlined /> Account Details</h4>
                </Col>
            </Row>
            <Row gutter={20}>
                <Col xs={24} xl={4}>
                    <Form.Item  
                        label="Tag"
                        name="ac_tag"
                    >
                        <Select disabled={true} >
                            <Option key="DrTag" value="Dr">Dr</Option>
                            <Option key="CrTag" value="Cr">Cr</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item name="account_title" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item>

                    {/* <Form.Item name="selected_payment_mode_text" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item>
                    
                    <Form.Item name="dr_account_id" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item>
                    <Form.Item name="payment_data" label="" hidden={true} >
                        <Input type="text" />
                    </Form.Item> */}

                </Col>

                <Col xs={24} xl={10}>
                <Form.Item  
                        label="Account"
                        name="account_id"
                        
                    >
                        <Select
                                            className="text-left"
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            allowClear={true}
                                            onChange = {(v,e)=>onAccountChange(v,e)}
                                        >

                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }


                                        </Select>
                                        </Form.Item>
                </Col>

                <Col xs={24} xl={4}>
                    <Form.Item name="amount" label="Amount"    >
                        <Input type="text" />
                    </Form.Item>
                </Col>
                
             
              
               
                <Col xs={24} xl={4}>
                    <Form.Item name="" label=" ">
                        <Button htmlType="button" className="custom-button-green"  icon={<PlusOutlined />}
                         onClick={props.addVoucherDetails}
                          >
                            Add  {
                                    props.transTagValue!="" ? <> &nbsp;{props.transTagValue=="RC" ? "Cr" : "Dr"}&nbsp; </>   : ""
                                }  Account
                        </Button>
                    </Form.Item>
                </Col>

                {/* <Col xs={24} xl={3}>
                    <Form.Item name="branch" label=" ">
                    <Button type="primary" block>
                        Edit
                    </Button>
                    
                    </Form.Item>
                </Col>
                <Col xs={24} xl={3}>
                    <Form.Item name="branch" label=" ">
                   
                    <Button type="primary" block>
                        Remove
                    </Button>
                    </Form.Item>
                </Col> */}
            </Row>
            <Row>
                <Col>
                    {
                        props.detailErrorMessage.length > 0 ? <><Tag color="error">{props.detailErrorMessage}</Tag></>:''
                    }
                </Col>
            </Row>

        

            {
                props.voucherDetailsList.length > 0 ? <><Table rowKey="voucher_detail_list" columns={columns} dataSource={props.voucherDetailsList} pagination={false} /></> : ''
            }
            


        </>
    )
}

export default AccountDrCrDetailsGeneralSingleRow